import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axiosInstance from "../axiosConfig";
import Swal from "sweetalert2";

export default function SharepointUpload() {

  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadedUrls, setUploadedUrls] = useState([]);

  /* ================= FILE SELECT ================= */
  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files);
    setFiles(selected);
  };

  /* ================= UPLOAD ================= */
  const handleUpload = async () => {
    if (files.length === 0) {
      return Swal.fire("Error", "Select files first", "warning");
    }

    try {
      setUploading(true);

      let urls = [];

      for (let file of files) {
        const formData = new FormData();
        formData.append("file", file);

        const res = await axiosInstance.post(
          "/api/sharepoint/upload",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" }
          }
        );

        urls.push(res.data.sharepointUrl);
      }

      setUploadedUrls(urls);

      Swal.fire("Success", "All files uploaded", "success");

    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Upload failed", "error");
    } finally {
      setUploading(false);
    }
  };

  /* ================= REMOVE FILE ================= */
  const removeFile = (index) => {
    setFiles(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="d-flex dashboard">

      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>

      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />

        <main className="main-container p-4">

          <h3 className="mb-4">SharePoint Upload</h3>

          <div className="card p-4 shadow-sm">

            {/* FILE INPUT */}
            <div className="mb-3">
              <label>Select Files</label>
              <input
                type="file"
                multiple
                className="form-control"
                onChange={handleFileChange}
              />
            </div>

            {/* PREVIEW */}
            {files.length > 0 && (
              <div className="mb-3">
                <h6>Selected Files</h6>
                <ul className="list-group">
                  {files.map((file, index) => (
                    <li key={index} className="list-group-item d-flex justify-content-between">
                      {file.name}
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => removeFile(index)}
                      >
                        Remove
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* UPLOAD BUTTON */}
            <button
              className="btn btn-primary"
              onClick={handleUpload}
              disabled={uploading}
            >
              {uploading ? "Uploading..." : "Upload to SharePoint"}
            </button>

          </div>

          {/* RESULT */}
          {uploadedUrls.length > 0 && (
            <div className="card p-4 mt-4 shadow-sm">
              <h5>Uploaded Files</h5>

              <ul className="list-group">
                {uploadedUrls.map((url, i) => (
                  <li key={i} className="list-group-item">
                    <a href={url} target="_blank" rel="noreferrer">
                      {url}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}

        </main>
      </div>
    </div>
  );
}